import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { brokerService } from './broker.service';
import { setAlertError } from '../alert/alert.slice';

const initialState = {
  client: null,
  account: null,
  daily: {
    balances: [],
    loading: false,
    loadingClientInfo: false
  },
  loading: false
};

export const brokerClientGetById = createAsyncThunk(
  'broker/clientGetById',
  async (id, thunkAPI) => {
    return await brokerService
      .brokerClientGetById(id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.msg));
        thunkAPI.rejectWithValue(err.msg);
      });
  }
);

export const brokerClientGetBalances = createAsyncThunk(
  'broker/clientGetBalances',
  async (id, thunkAPI) => {
    return await brokerService
      .brokerClientGetBalances(id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.msg));
        thunkAPI.rejectWithValue(err.msg);
      });
  }
);

export const brokerClientSearch = createAsyncThunk(
  'broker/clientSearch',
  async (data, thunkAPI) => {
    return await brokerService
      .brokerClientSearch(data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        const err = error.response.data;
        thunkAPI.dispatch(setAlertError(err.message));
        return thunkAPI.rejectWithValue(err.message);
      });
  }
);

export const brokerSlice = createSlice({
  name: 'broker',
  initialState: initialState,
  reducers: {
    clearSearch(state) {
      state.results = [];
      state.searching = false;
    },
    clearAccount(state) {
      state.account = null;
      state.client = null;
    }
  },
  extraReducers: {
    [brokerClientGetById.pending]: (state) => {
      state.loadingClientInfo = true;
      state.loading = true;
    },
    [brokerClientGetById.fulfilled]: (state, action) => {
      state.client = action.payload.client;
      state.loadingClientInfo = false;
      state.loading = false;
    },
    [brokerClientGetById.rejected]: (state) => {
      state.loadingClientInfo = false;
      state.loading = false;
    },

    [brokerClientGetBalances.pending]: (state) => {
      state.loadingBalances = true;
      state.loading = true;
    },
    [brokerClientGetBalances.fulfilled]: (state, action) => {
      state.account = action.payload;
      state.loadingBalances = false;
      state.loading = false;
    },
    [brokerClientGetBalances.rejected]: (state) => {
      state.loadingBalances = false;
      state.loading = false;
    },

    [brokerClientSearch.pending]: (state) => {
      state.searching = true;
      state.loading = true;
    },
    [brokerClientSearch.fulfilled]: (state, action) => {
      state.results = action.payload.results;
      state.searching = false;
      state.loading = false;
    },
    [brokerClientSearch.rejected]: (state) => {
      state.searching = false;
      state.loading = false;
    }
  }
});

export const { clearSearch, clearAccount } = brokerSlice.actions;

export default brokerSlice.reducer;
